import React from "react";
import Chart from "react-google-charts";
import {arrayToDataTable} from "../../../config/Utils";
import {TIP_TEXT} from "../../../config/constants";
import {CircularProgress} from "@material-ui/core";

export const HomeSidebarComponent = (props) => {
    return (
        <div className="ibox">
            <div className="ibox-content">
                <h5>Distribution of covered countries per continent</h5>
                {/*<h1 className="no-margins">{props.drugsCount}</h1>*/}
                {/*<small className='font-weight-bold'>Total drugs</small>*/}
                {/*<h1 className="mt-2 mb-0">{props.countriesCovered}</h1>*/}
                {/*<small className='font-weight-bold'>Countries</small>*/}
                {/*<h1 className="mt-2 mb-0">{props.countriesPerContinent.length}</h1>*/}
                {/*<small className='font-weight-bold'>Continents</small>*/}
                <div style={{minHeight: 400 + 'px'}}>
                    <Chart
                        height={400}
                        chartType="PieChart"
                        loader={<div style={{minHeight: "100%"}} className={'d-flex align-items-center justify-content-center'}><CircularProgress/></div>}
                        data={arrayToDataTable(props.countriesPerContinent, ['Continent', 'Country count'])}
                        options={{
                            legend: 'none',
                            pieHole: 0.3,
                        }}
                    />
                </div>
                <small className="text-justify"><b>TIP: </b>{TIP_TEXT}</small>
            </div>
        </div>
    )
}
